import { useTranslation } from "@/hooks/useTranslation";
import { cn } from "@/lib/utils";
import { timestampsAtom } from "@/store/timestampAtom";
import { useAtom } from "jotai";
import { type FC, useMemo } from "react";

interface FilterSelectorProps {
	selectedFilter: string;
	onChange: (filter: string) => void;
}

const DAY = 24 * 60 * 60 * 1000;

const DashboardFilterSelector: FC<FilterSelectorProps> = ({
	selectedFilter,
	onChange,
}) => {
	const { t } = useTranslation();
	const [{ start_datetime }] = useAtom(timestampsAtom);

	const options = useMemo(
		() => [
			{
				value: start_datetime.toISOString(),
				label: t("home.lastHours", { time: 24 }),
			},
			{
				value: new Date(start_datetime.getTime() - 6 * DAY).toISOString(),
				label: t("home.lastDays", { time: 7 }),
			},
			{
				value: new Date(start_datetime.getTime() - 29 * DAY).toISOString(),
				label: t("home.lastDays", { time: 30 }),
			},
		],
		[start_datetime, t],
	);

	return (
		<fieldset
			className="dashboard-period-picker"
			aria-label={t("home.performance")}
		>
			{options.map((option) => (
				<label
					key={option.value}
					className={cn(
						"dashboard-period-option",
						selectedFilter === option.value && "is-active",
					)}
				>
					<input
						type="radio"
						name="dashboard-period"
						value={option.value}
						checked={selectedFilter === option.value}
						onChange={() => onChange(option.value)}
						className="sr-only"
					/>
					{option.label}
				</label>
			))}
		</fieldset>
	);
};

export default DashboardFilterSelector;
